function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8.00027C0 4.00976 3.12195 0.727539 7.0303 0.727539C8.31515 0.727539 9.52036 1.08472 10.5563 1.70704C10.9006 1.91388 11.0121 2.36067 10.8053 2.70498C10.5984 3.0493 10.1516 3.16075 9.80731 2.95391C8.9891 2.46239 8.04157 2.18208 7.0303 2.18208C3.97652 2.18208 1.45455 4.76086 1.45455 8.00027C1.45455 11.2397 3.97652 13.8184 7.0303 13.8184C8.04157 13.8184 8.9891 13.5381 9.80731 13.0466C10.1516 12.8398 10.5984 12.9512 10.8053 13.2955C11.0121 13.6399 10.9006 14.0867 10.5563 14.2935C9.52036 14.9158 8.31515 15.273 7.0303 15.273C3.12195 15.273 0 11.9908 0 8.00027ZM11.8494 4.57692C12.1334 4.2929 12.5939 4.2929 12.8779 4.57692L15.787 7.48601C16.071 7.77002 16.071 8.23051 15.787 8.51453L12.8779 11.4236C12.5939 11.7076 12.1334 11.7076 11.8494 11.4236C11.5654 11.1396 11.5654 10.6791 11.8494 10.3951L13.5169 8.72754H5.81818C5.41652 8.72754 5.09091 8.40193 5.09091 8.00027C5.09091 7.5986 5.41652 7.27299 5.81818 7.27299H13.5169L11.8494 5.60543C11.5654 5.32142 11.5654 4.86093 11.8494 4.57692Z",
  fill: "currentColor"
});

function SvgSxLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxLogout);
export default __webpack_public_path__ + "static/media/sx-logout.b8a666ec.svg";
export { ForwardRef as ReactComponent };